import { useState, useEffect } from 'react';
import { filterVacanciesByDepartment } from '../utils';
import { DEFAULT_DEPARTMENT, ALL_DEPARTMENTS_TEXT } from '../../shared/config/constants';

const useFilterByDepartment = (vacancies) => {
    const [filteredVacancies, setFilteredVacancies] = useState(vacancies);
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        if (!vacancies?.length) {
            setDepartments([]);
            setFilteredVacancies(vacancies);
            return
        }

        // Extract unique departments
        const uniqueDepartments = [
            { id: DEFAULT_DEPARTMENT, name: ALL_DEPARTMENTS_TEXT },
            ...new Map(
                vacancies
                    .filter(vacancy => vacancy?.department)
                    .map(vacancy => [
                        vacancy.department.id,
                        vacancy.department
                    ])
            ).values()
        ];

        setDepartments(uniqueDepartments);

        setFilteredVacancies(vacancies);
    }, [vacancies]);

    const handleDepartmentChange = (departmentId) => {
        const filtered = filterVacanciesByDepartment(vacancies, departmentId);
        setFilteredVacancies(filtered);
    };

    return {
        filteredVacancies,
        departments,
        handleDepartmentChange,
    };
};

export default useFilterByDepartment;
